import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9c83d96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "contentbox" }
const _hoisted_3 = { class: "contentbox-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "标题:", -1))
const _hoisted_5 = { class: "row-cont" }
const _hoisted_6 = { class: "contentbox-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "所在区域:", -1))
const _hoisted_8 = { class: "row-cont" }
const _hoisted_9 = { class: "contentbox-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "创建时间:", -1))
const _hoisted_11 = { class: "row-cont" }
const _hoisted_12 = { class: "contentbox-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "巡检员:", -1))
const _hoisted_14 = { class: "row-cont" }
const _hoisted_15 = { class: "contentbox-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "部门:", -1))
const _hoisted_17 = { class: "row-cont" }
const _hoisted_18 = { class: "contentbox-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "处理结果:", -1))
const _hoisted_20 = { class: "contentbox-row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "限定整改时间:", -1))
const _hoisted_22 = { class: "row-cont" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentbox-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "备注:")
], -1))
const _hoisted_24 = { class: "contentbox-row" }
const _hoisted_25 = { class: "row-cont" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentbox-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "附件:")
], -1))
const _hoisted_27 = { class: "contentbox-row" }
const _hoisted_28 = { class: "row-cont" }
const _hoisted_29 = ["src", "onClick"]
const _hoisted_30 = { class: "contentbox" }
const _hoisted_31 = { class: "changearea" }
const _hoisted_32 = { class: "changearea-row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "分配人:", -1))
const _hoisted_34 = { class: "row-cont" }
const _hoisted_35 = { class: "changearea-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "整改人:", -1))
const _hoisted_37 = { class: "row-cont" }
const _hoisted_38 = { class: "changearea-row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "审核人:", -1))
const _hoisted_40 = { class: "row-cont" }
const _hoisted_41 = {
  key: 0,
  class: "contentbox-row"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "整改完成时间:", -1))
const _hoisted_43 = { class: "row-cont" }
const _hoisted_44 = { class: "contentbox-row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "超期天数:", -1))
const _hoisted_46 = { class: "row-cont" }
const _hoisted_47 = { class: "contentbox-row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "问题处理次数:", -1))
const _hoisted_49 = { class: "row-cont" }
const _hoisted_50 = { class: "contentbox-row" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "问题审核次数:", -1))
const _hoisted_52 = { class: "row-cont" }
const _hoisted_53 = { class: "contentbox" }
const _hoisted_54 = { class: "btnbox" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { class: "step-info" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" 整改时间：")
const _hoisted_59 = { style: {"color":"#1e2124"} }
const _hoisted_60 = { class: "step-cont step-block" }
const _hoisted_61 = ["src"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "整改备注：", -1))
const _hoisted_63 = { class: "comment" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "附件：")
], -1))
const _hoisted_65 = ["src"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "整改单：")
], -1))
const _hoisted_67 = ["src"]
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { class: "step-info" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" 审核日期：")
const _hoisted_71 = { style: {"color":"#1e2124"} }
const _hoisted_72 = { class: "step-cont step-block" }
const _hoisted_73 = ["src"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "审核结论：", -1))
const _hoisted_75 = { class: "comment" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "附件：")
], -1))
const _hoisted_77 = ["src"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "整改单：")
], -1))
const _hoisted_79 = ["src"]
const _hoisted_80 = { class: "contentbox" }
const _hoisted_81 = { class: "submitbox" }
const _hoisted_82 = { class: "contentbox" }
const _hoisted_83 = { class: "contentbox-row" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "备注:", -1))
const _hoisted_85 = { class: "row-cont" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentbox-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "附件:")
], -1))
const _hoisted_87 = { class: "contentbox-row" }
const _hoisted_88 = { class: "row-cont" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentbox-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "整改单:")
], -1))
const _hoisted_90 = { class: "contentbox-row" }
const _hoisted_91 = { class: "row-cont" }
const _hoisted_92 = { class: "btnbox" }
const _hoisted_93 = { style: {"height":"100%","display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_94 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_personliable_dialog = _resolveComponent("personliable-dialog")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.infodata.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.infodata.areaName), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.infodata.createDate), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.infodata.createName), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.infodata.deptName), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          (_ctx.infodata.result !== 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "row-cont",
                style: _normalizeStyle({
            color:
              _ctx.infodata.status === 1
                ? '#D69340'
                : _ctx.infodata.status === 2
                ? '#D0D9E0'
                : '#19B064',
          })
              }, _toDisplayString(_ctx.infodata.status === 1
              ? "未处理"
              : _ctx.infodata.status === 2
              ? "已处理"
              : "已解决"), 5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.infodata.limitDate != null ? _ctx.infodata.limitDate.substr(0, 10) : "无"), 1)
        ]),
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.infodata.remark), 1)
        ]),
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infodata.imgFileList, (item, index) => {
              return (_openBlock(), _createElementBlock("img", {
                class: "remark-pic",
                src: item.url,
                alt: "",
                key: index,
                onClick: ($event: any) => (_ctx.previewimgfun(item.url))
              }, null, 8, _hoisted_29))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.infodata.allocateName ? _ctx.infodata.allocateName : "未分配"), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.infodata.changePersonName ? _ctx.infodata.changePersonName : "未分配"), 1)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.infodata.checkUserName ? _ctx.infodata.checkUserName : "未分配"), 1)
          ])
        ]),
        (_ctx.infodata.status == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.infodata.updateDate), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.infodata.outLimitDay), 1)
        ]),
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.infodata.countDeal), 1)
        ]),
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.infodata.countCheck), 1)
        ])
      ]),
      (
        (_ctx.queryPloyLoad.checkType == 2 && _ctx.$route.params.status == 1) ||
        (_ctx.queryPloyLoad.checkType == 1 &&
          (_ctx.infodata.flag == 3 || _ctx.infodata.flag == 4))
      )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_van_form, {
                ref: "sellForm",
                "show-error": true,
                "show-error-message": false,
                "validate-trigger": "onSubmit"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: _ctx.subform.changePersonName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.subform.changePersonName) = $event)),
                    "is-link": "",
                    readonly: "",
                    "input-align": "right",
                    label: "整改人",
                    placeholder: "请选择处理人",
                    rules: [{ required: true, message: '处理人必选' }],
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fOpenchangePerson(1)))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, {
                    modelValue: _ctx.subform.checkUserName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.subform.checkUserName) = $event)),
                    rules: [{ required: true, message: '审核人必选' }],
                    "is-link": "",
                    readonly: "",
                    "input-align": "right",
                    label: "审批人",
                    placeholder: "请选择审核人",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fOpenchangePerson(2)))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 512)
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", {
                class: "noadoptbtn",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fClose && _ctx.fClose(...args)))
              }, "关闭事件"),
              _createElementVNode("div", {
                class: "adoptbtn",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fSumbit && _ctx.fSumbit(...args)))
              }, "提交")
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.infodata.dealList && _ctx.infodata.dealList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createVNode(_component_van_steps, {
                    active: _ctx.active,
                    direction: "vertical"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infodata.dealList, (li, i) => {
                        return (_openBlock(), _createBlock(_component_van_step, { key: i }, {
                          default: _withCtx(() => [
                            (li.status == 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                  _createElementVNode("div", _hoisted_57, [
                                    _createElementVNode("div", null, [
                                      _hoisted_58,
                                      _createElementVNode("span", _hoisted_59, _toDisplayString(li.createDate), 1)
                                    ]),
                                    _createElementVNode("div", null, "整改人: " + _toDisplayString(li.createName), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_60, [
                                    _createElementVNode("img", {
                                      class: "logo",
                                      src: require('@/assets/zgwc.png')
                                    }, null, 8, _hoisted_61),
                                    _hoisted_62,
                                    _createElementVNode("div", _hoisted_63, _toDisplayString(li.remark), 1),
                                    _hoisted_64,
                                    _createElementVNode("div", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.fileList, (item, index) => {
                                        return (_openBlock(), _createElementBlock("img", {
                                          src: item.url,
                                          key: index,
                                          style: {"width":"80px","height":"80px","border-radius":"8px","margin":"0 8px 8px 0","vertical-align":"middle"}
                                        }, null, 8, _hoisted_65))
                                      }), 128))
                                    ]),
                                    _hoisted_66,
                                    _createElementVNode("div", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.checkFileList, (item, index) => {
                                        return (_openBlock(), _createElementBlock("img", {
                                          src: item.url,
                                          key: index,
                                          style: {"width":"80px","height":"80px","border-radius":"8px","margin":"0 8px 8px 0","vertical-align":"middle"}
                                        }, null, 8, _hoisted_67))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                  _createElementVNode("div", _hoisted_69, [
                                    _createElementVNode("div", null, [
                                      _hoisted_70,
                                      _createElementVNode("span", _hoisted_71, _toDisplayString(li.createDate), 1)
                                    ]),
                                    _createElementVNode("div", null, "审核人: " + _toDisplayString(li.createName), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("img", {
                                      class: "logo",
                                      src: 
                    li.status == 3
                      ? require('@/assets/sptg.png')
                      : require('@/assets/spth.png')
                  
                                    }, null, 8, _hoisted_73),
                                    _hoisted_74,
                                    _createElementVNode("div", _hoisted_75, _toDisplayString(li.remark), 1),
                                    _hoisted_76,
                                    _createElementVNode("div", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.fileList, (item, index) => {
                                        return (_openBlock(), _createElementBlock("img", {
                                          class: "remark-pic",
                                          src: item.url,
                                          key: index
                                        }, null, 8, _hoisted_77))
                                      }), 128))
                                    ]),
                                    _hoisted_78,
                                    _createElementVNode("div", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.checkFileList, (item, index) => {
                                        return (_openBlock(), _createElementBlock("img", {
                                          class: "remark-pic",
                                          src: item.url,
                                          key: index
                                        }, null, 8, _hoisted_79))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["active"])
                ]))
              : _createCommentVNode("", true)
          ], 64)),
      (
        (_ctx.queryPloyLoad.checkType == 3 && _ctx.infodata.status == 1) ||
        (_ctx.queryPloyLoad.checkType == 1 &&
          (_ctx.infodata.flag == 1 || _ctx.infodata.flag == 4))
      )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_80, [
              _createVNode(_component_van_form, {
                ref: "handleForm",
                "show-error-message": false,
                "show-error": true,
                "validate-trigger": "onSubmit"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: _ctx.remark,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.remark) = $event)),
                    rows: "2",
                    autosize: "",
                    label: "处理结果",
                    type: "textarea",
                    maxlength: "200",
                    placeholder: "请输入备注",
                    rules: [{ required: true, message: '请输入' }],
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_field, { label: "附件" }, {
                    input: _withCtx(() => [
                      _createVNode(_component_van_uploader, {
                        modelValue: _ctx.uploader,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.uploader) = $event)),
                        "after-read": _ctx.afterRead,
                        multiple: _ctx.$isIOS()
                      }, null, 8, ["modelValue", "after-read", "multiple"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_field, { label: "整改单" }, {
                    input: _withCtx(() => [
                      _createVNode(_component_van_uploader, {
                        modelValue: _ctx.checkUploader,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.checkUploader) = $event)),
                        "after-read": _ctx.afterRead,
                        multiple: _ctx.$isIOS()
                      }, null, 8, ["modelValue", "after-read", "multiple"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512)
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", {
                class: "submit-btn",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.fHandle && _ctx.fHandle(...args)))
              }, "处理完成")
            ])
          ], 64))
        : _createCommentVNode("", true),
      (
        (_ctx.queryPloyLoad.checkType == 4 && _ctx.infodata.status == 2) ||
        (_ctx.queryPloyLoad.checkType == 1 && _ctx.infodata.flag == 2)
      )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", _hoisted_83, [
                _hoisted_84,
                _createElementVNode("div", _hoisted_85, [
                  _createVNode(_component_van_field, {
                    modelValue: _ctx.remark,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.remark) = $event)),
                    rows: "2",
                    autosize: "",
                    type: "textarea",
                    placeholder: "请输入备注"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_86,
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _createVNode(_component_van_field, { name: "uploader" }, {
                    input: _withCtx(() => [
                      _createVNode(_component_van_uploader, {
                        modelValue: _ctx.uploader,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.uploader) = $event)),
                        "after-read": _ctx.afterRead,
                        multiple: _ctx.$isIOS()
                      }, null, 8, ["modelValue", "after-read", "multiple"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _hoisted_89,
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _createVNode(_component_van_field, { name: "uploader" }, {
                    input: _withCtx(() => [
                      _createVNode(_component_van_uploader, {
                        modelValue: _ctx.checkUploader,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.checkUploader) = $event)),
                        "after-read": _ctx.afterRead,
                        multiple: _ctx.$isIOS()
                      }, null, 8, ["modelValue", "after-read", "multiple"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("div", {
                class: "noadoptbtn nopass",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.examine(2)))
              }, "不通过"),
              _createElementVNode("div", {
                class: "adoptbtn",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.examine(1)))
              }, "通过")
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_overlay, {
      show: _ctx.show,
      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.show = false)),
      "z-index": "10"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("img", {
            src: _ctx.previewimg,
            style: {"width":"100%"}
          }, null, 8, _hoisted_94)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_personliable_dialog, { ref: "personliable" }, null, 512),
    _createVNode(_component_van_dialog, {
      show: _ctx.showClose,
      "onUpdate:show": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showClose) = $event)),
      title: "关闭事件",
      "show-cancel-button": "",
      onCancel: _ctx.fEventCancel,
      onConfirm: _ctx.fEventConfirm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: _ctx.reason,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.reason) = $event)),
          placeholder: "请填写关闭理由"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show", "onCancel", "onConfirm"])
  ], 64))
}